import React from "react";
import { Link } from "react-router-dom";
import reliveLogo from "../assets/tv.svg";
import relivePreview from "../assets/cta0.png";
import aboutLogo from "../assets/lamp.svg";
import aboutPreview from "../assets/aboutHero.png";
import resmailLogo from "../assets/aff.svg";
import "./cards.css";
import { useLanguage } from '../contexts/LanguageContext';

const AffiliateCards = () => {
  const { isArabic } = useLanguage();

  const translations = {
    replayDJSets: isArabic ? 'استمع إلى موسيقى الدي چاي المفضل لك في أي وقت على منصتنا الحصرية.' : 'Replay your favorite DJ sets anytime on our exclusive platform.',
    aboutUs: isArabic ? 'من إحنا؟' : 'About Us',
    aboutDescription: isArabic ? 'تحب تتعرف أكثر على فريكس أوف نيتشر؟' : 'Would you like to know more about Freaks of Nature?',
    affiliate: isArabic ? 'أفلييت' : 'Affiliate',
    affiliateDescription: isArabic ? 'انضم إلى برنامجنا واربح جوائز مذهلة' : 'Join our program and win amazing prizes'
  };

  return (
    <div className="affiliate-card-grid">
      <a
        className="affiliate-card affiliate-card--relive"
        href="https://www.youtube.com/@relivefreaksofnature/featured"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="affiliate-card__content">
          <img
            src={relivePreview}
            alt="Relive by Freaks of Nature"
            className="affiliate-card__logo"
            loading="lazy"
          />
          <p className="affiliate-card__description affiliate-card__description--relive">
            {translations.replayDJSets}
          </p>
        </div>
        <div className="about-content-img">
          <img
            src={reliveLogo}
            alt="Relive platform preview"
            className="affiliate-card__logo-about affiliate-card__logo-about--relive"
            loading="lazy"
          />
        </div>
      </a>

      <div className="affiliate-card-column">
        <Link to="/about" className="affiliate-card affiliate-card--about">
          <div className="affiliate-card__content-about about-content">
            <div className="about-content-text">
              <h3 className="affiliate-card__title">{translations.aboutUs}</h3>
              <p className="affiliate-card__description">
                {translations.aboutDescription}
              </p>
            </div>
            <div className="about-content-img">
              <img
                src={aboutLogo}
                alt="About Freaks of Nature"
                className="affiliate-card__logo-about affiliate-card__logo-about--about"
                loading="lazy"
              />
            </div>
          </div>
        </Link>

        <Link to="/affiliate" className="affiliate-card affiliate-card--affiliate">
          <div className="affiliate-card__content-about about-content">
            <div className="about-content-text">
              <h3 className="affiliate-card__title">{translations.affiliate}</h3>
              <p className="affiliate-card__description">
                {translations.affiliateDescription}
              </p>
            </div>
            <div className="about-content-img">
              <img
                src={resmailLogo}
                alt="Affiliate Program"
                className="affiliate-card__logo-about affiliate-card__logo-about--affiliate"
                loading="lazy"
              />
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default AffiliateCards;